<template>
  <div :class="classModifiers">
    <div class="insight-widget__header">Insights</div>
    <div class="insight-widget__line"></div>
    <div class="insight-widget__content">
      <insight-panel text="All Articles" :href="allArticlesLink" :away="allArticlesAway">
        <div class="insight-widget__articles">
          <insight-link
            v-for="link in tumblr"
            :key="link.title"
            :title="link.title"
            :href="createLink(link.url)"
            :url="link.url"
          >
          </insight-link>
        </div>
      </insight-panel>
    </div>
  </div>
</template>

<script src="./insight-widget.js"></script>
<style src="./insight-widget.scss" lang="scss"></style>
